// Stage 201-S: render-null mount surface for the witness/joint subscriber.
//
// Mounted in AuthedApp.tsx as a sibling to LaughterSubscriber. Renders
// nothing. Its sole purpose is to attach useWitnessReframeSubscriber to the
// React tree. When `enabled === false` (laughter off OR witness off), the
// hook still mounts but its useEffect short-circuits at the gate.

import { useWitnessReframeSubscriber } from './useWitnessReframeSubscriber';
import type { ChatMessage } from '../../hooks/useChat';

interface WitnessReframeSubscriberProps {
  enabled: boolean;
  conversationId: string | null;
  latestUserMsg: ChatMessage | null;
  /** Stage 202-J: gates the two-pass shared-ground deep joint path. */
  sharedGroundEnabled: boolean;
}

export function WitnessReframeSubscriber(
  props: WitnessReframeSubscriberProps,
): null {
  useWitnessReframeSubscriber(props);
  return null;
}
